// Auditrail.styles.ts

export const gridStyles = `
  /* Contenedor principal (card) */
  .bitacora-container {
    padding: 24px;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    margin: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  }

  /* Título */
  .bitacora-container h2 {
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 24px;
    color: #333;
    border-bottom: 2px solid #f0f0f0;
    padding-bottom: 10px;
  }

  /* ===== Barra de filtros (arriba) ===== */
  .filters-bar {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 12px;
    align-items: end;
    margin-bottom: 14px;
  }

  .filter-field {
    grid-column: span 3;
    display: flex;
    flex-direction: column;
  }

  .filter-field label {
    font-size: 12px;
    color: #5f6368;
    margin-bottom: 6px;
  }

  .filter-input {
    height: 36px;
    border: 1px solid #d0d7de;
    border-radius: 6px;
    padding: 0 10px;
    outline: none;
    transition: border-color 0.2s ease;
  }

  .filter-input:focus {
    border-color: #90caf9;
    box-shadow: 0 0 0 3px rgba(144, 202, 249, 0.25);
  }

  .filter-actions {
    grid-column: span 3;
    display: flex;
    gap: 8px;
    justify-content: flex-start;
  }

  .btn {
    height: 36px;
    padding: 0 14px;
    border-radius: 6px;
    border: 1px solid #d0d7de;
    background: #fff;
    color: #333;
    cursor: pointer;
  }

  .btn.primary {
    background: #0d47a1;
    color: #fff;
    border-color: #0d47a1;
  }

  .btn:hover {
    filter: brightness(0.98);
  }

  /* Responsive: en pantallas medianas/pequeñas los inputs ocupan más columnas */
  @media (max-width: 1200px) {
    .filter-field { grid-column: span 4; }
    .filter-actions { grid-column: span 4; }
  }
  @media (max-width: 768px) {
    .filters-bar { grid-template-columns: repeat(2, 1fr); }
    .filter-field, .filter-actions { grid-column: span 2; }
  }

  /* --- Estilos para el DataGrid de DevExtreme --- */

  /* Encabezados */
  .custom-grid .dx-datagrid-headers .dx-datagrid-text-content {
    color: #0d47a1;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
  }
  .custom-grid .dx-datagrid-headers {
    background-color: #e3f2fd;
    border-bottom: 2px solid #90caf9;
  }

  /* Filas alternas y hover */
  .custom-grid .dx-data-row:nth-of-type(even) {
    background-color: #fafafa;
  }
  .custom-grid .dx-data-row:hover {
    background-color: #f0f8ff;
  }

  /* Alineación vertical del contenido de las celdas */
  .custom-grid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: middle;
  }
`;
